import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearVehicleTypes, fetchVehicleTypes } from '../../../../store/slices/vehicle';

export const useFetchVehicleTypes = () => {
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const vehicleTypes = useSelector(state => state.vehicle.vehicleType);

  const fetchAllVehicleTypes = useCallback(() => {
    try {
      setLoading(true);
      if (vehicleTypes.length === 0) {
        dispatch(fetchVehicleTypes());
      }
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    fetchAllVehicleTypes();
    return () => dispatch(clearVehicleTypes());
  }, [dispatch, fetchAllVehicleTypes]);

  return {
    loading,
    vehicleTypes,
  };
};